import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { SvgIcon } from './Icon';

export default function SmartAppBanner() {
  const { t } = useTranslation();
  const [dismissed, setDismissed] = useState(() => {
    try { return localStorage.getItem('appBannerDismissed') === '1'; } catch { return false; }
  });

  if (dismissed) return null;
  if (window.Capacitor?.isNativePlatform?.()) return null;

  const ua = navigator.userAgent;
  const isIOS = /iPhone|iPad|iPod/.test(ua);
  const isSafari = /Safari/.test(ua) && !/CriOS|FxiOS|EdgiOS|OPiOS/.test(ua);
  if (!isIOS || isSafari) return null;

  const handleDismiss = () => {
    try { localStorage.setItem('appBannerDismissed', '1'); } catch {}
    setDismissed(true);
  };

  return (
    <div style={{
      position: 'fixed', bottom: 0, left: 0, right: 0, zIndex: 999,
      background: 'linear-gradient(135deg, #166534 0%, #15803D 100%)',
      color: 'white', padding: '12px 14px',
      display: 'flex', alignItems: 'center', gap: 10,
      boxShadow: '0 -2px 10px rgba(0,0,0,0.15)',
      fontFamily: 'Noto Sans, sans-serif',
    }}>
      <button
        onClick={handleDismiss}
        style={{
          background: 'none', border: 'none', color: 'rgba(255,255,255,0.7)',
          fontSize: '1.3rem', cursor: 'pointer', padding: '0 4px', lineHeight: 1,
        }}
        aria-label="Close"
      >
        ×
      </button>
      <div style={{
        width: 36, height: 36, borderRadius: 8,
        background: 'rgba(255,255,255,0.15)',
        display: 'flex', alignItems: 'center', justifyContent: 'center',
        flexShrink: 0,
      }}>
        <SvgIcon name="shield" size={20} color="white" strokeWidth={2}/>
      </div>
      <div style={{ flex: 1, minWidth: 0 }}>
        <div style={{ fontWeight: 700, fontSize: '0.82rem', lineHeight: 1.3 }}>
          {t('appBanner.getApp')}
        </div>
      </div>
      <a
        href="https://apps.apple.com/app/id6761441535"
        target="_blank"
        rel="noreferrer"
        style={{
          background: 'white', color: '#166534', borderRadius: 16,
          padding: '6px 16px', fontWeight: 700, fontSize: '0.78rem',
          textDecoration: 'none', flexShrink: 0,
        }}
      >
        {t('appBanner.open')}
      </a>
    </div>
  );
}
